import { CommonPatientResponse } from '@/api/services/common/patient/common-patient.dto'
import { CustomerResponse } from '@/api/services/billing/common-customer/billing-common-customer.dto'

export interface BillingModalCustomerCreationParams {
    patient: CommonPatientResponse
}

export interface BillingModalCustomerCreationState {
    customer: Partial<CustomerResponse>
}
export const initialBillingModalCustomerCreationState =
    (): BillingModalCustomerCreationState => ({
        customer: { active: true }
    })
